export default __webpack_public_path__ + "static/media/professor.40ce6089.png";